import {HttpServices} from "../Helpers";
import {PHP_V13_URL} from "../api/urls";

export const GetAllTimeZones = async ({limit = 100, company_uuid}) => {
  return await HttpServices.get(
      `${PHP_V13_URL}/api/helper/${process.env.REACT_APP_VERSION_API}/timezone`,
      {
        params: {
          limit,
          company_uuid,
        },
      }
  )
      .then((data) => data)
      .catch((error) => error.response);
};

export const ScheduleInterview = async (body) => {
  return await HttpServices.post(
      `${PHP_V13_URL}/api/recruiter/schedule/${process.env.REACT_APP_VERSION_API}/interview`,
      body,
  )
      .then((data) => data)
      .catch((error) => error.response);
};

export const DeleteInterview = async ({uuid}) => {
  return await HttpServices.delete(
      `${PHP_V13_URL}/api/recruiter/schedule/${process.env.REACT_APP_VERSION_API}/interview`,
      {
        params: {uuid},
      }
  )
      .then((data) => data)
      .catch((error) => error.response);
};

export const GetAllMeetingProviders = async ({type}) => {
    return await HttpServices.get(
        `${PHP_V13_URL}/api/helper/${process.env.REACT_APP_VERSION_API}/check-company-providers`,
        {
            params: {
                type
            },
        }
    )
        .then((data) => data)
        .catch((error) => error.response);
};
